'use client'
import { useTranslation } from '@/app/i18n/client'
import { months } from '@/app/utils/numberToMonth'
import ReactSelect, { components } from 'react-select'
import { Checkbox } from './ui/checkbox'
import { colourStyles } from './ui/select/selectStyle'

interface AvailabiltyMultiSelectProps {
  selectedMonth: string[]
  setValue: (value: string[]) => void
}

const AvailablityMultiSelect = ({
  selectedMonth,
  setValue,
}: AvailabiltyMultiSelectProps) => {
  const { t } = useTranslation()

  const monthsList = months?.map((month: string) => ({
    value: month,
    label: t(month),
  }))
  const monthOptions = [
    { value: 'All Year Round', label: t('All Year Round') },
    ...(months ? monthsList : []),
  ]

  const CustomOption = (props: any) => {
    const { isSelected, label } = props
    return (
      <components.Option {...props} className="!flex items-center gap-2">
        <div className="!flex items-center gap-2">
          <Checkbox
            className=" h-[15px] w-[15px] self-center"
            checked={isSelected || selectedMonth?.includes('All Year Round')}
            onChange={() => null}
          />
          <span> {label}</span>
        </div>
      </components.Option>
    )
  }

  return (
    <ReactSelect
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      value={
        selectedMonth?.includes('All Year Round')
          ? monthsList
          : selectedMonth?.map((month: string) => ({
              value: month,
              label: month,
            }))
      }
      onChange={(selectedOptions, value) => {
        const selectedValues = selectedOptions
          ? selectedOptions?.map((option) => option.value)
          : []

        if (
          selectedValues?.includes('All Year Round') &&
          !selectedMonth?.includes('All Year Round')
        ) {
          setValue(monthOptions?.map((option) => option.value))
        } else {
          if (value?.option?.value === 'All Year Round') {
            setValue([])
          } else {
            setValue(selectedValues?.filter((val) => val !== 'All Year Round'))
          }
        }
      }}
      styles={colourStyles}
      options={monthOptions}
      placeholder={
        selectedMonth && selectedMonth.length <= 0
          ? t('Select Available Months')
          : ''
      }
      isMulti
      components={{ Option: CustomOption }}
    />
  )
}

export default AvailablityMultiSelect
